// eslint-disable-next-line no-shadow
enum DialogResult {
  NO,
  YES
}

export default DialogResult;
